import { type PayloadAction } from '@reduxjs/toolkit';
import type { PriceStrategyConfigWithRelations } from '@snap-types/models/price-strategy-config';
import type { QuotePriceField } from '@ui/config/price/constants';
import { type WritableDraft } from 'immer';

import { type QuoteBuilderStateType } from '../../types/state';
import { handlePriceFieldChange } from '../logic/price-fields';
import { buildElementId } from '../utilities/element-id';

type PriceFieldChangedParams = {
  quoteLineUuid: string;
  quotePriceUuid: string;
  field: QuotePriceField;
  value: string;
  priceStrategyConfigs: PriceStrategyConfigWithRelations[];
};

export function priceFieldChanged(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<PriceFieldChangedParams>,
) {
  const { value, quoteLineUuid, quotePriceUuid, field, priceStrategyConfigs } =
    action.payload;

  const elementId = buildElementId({
    uuid: quotePriceUuid,
    field,
  });

  state.rawFieldValues[elementId] = value;

  handlePriceFieldChange({
    state,
    quoteLineUuid,
    quotePriceUuid,
    field,
    value,
    priceStrategyConfigs,
  });
}
